import { Type } from 'class-transformer';
import { QaTesterRawDto } from './qa-tester-raw-dto';

export class QaTestersSaveParameterDto {
    @Type(() => QaTesterRawDto)
    qaTesters: QaTesterRawDto[];
}
